module.exports = __webpack_public_path__ + "img/24-2500-nav.02c26290.png";